import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_perform_any_type_of_hot_work_ie_welding_soldering'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_perform_any_type_of_hot_work_ie_welding_soldering',
  name: 'Does the facility perform any type of "hot work" (i.e. welding, soldering etc.)?',
  description:
    'Hot work: Includes welding and allied processes, grinding, heat treating, thawing pipe, and similar applications producing or using a spark, flame, or heat that it is sufficient to start a fire. Also includes laboratory operations that are open flame in nature.\r\r\n\r\r\nQuestions in this category only focus on heat exposure related to "Hot Work" and not to other heat stress risk (e.g., working close to a furnace/ oven or in high temperature environments). ',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-34',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16120,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
